import hts from '../../../../public/webp/project/htsv2.webp';
import planned from '../../../../public/webp/project/planned.webp';
import wikifarmer from '../../../../public/webp/project/Wikifarmer.webp';
import spacerenta from '../../../../public/webp/project/spacerenta.webp';
import ticeGroup from '../../../../public/webp/project/ticeGroup.webp';
import ketoCycle from '../../../../public/webp/project/keto-cycle.webp';
import dataPacket from '../../../../public/webp/project/datapacket.webp';
import reup from '../../../../public/webp/project/reup.webp';
import buildersSpec from '../../../../public/webp/project/Buildersspec.webp';
import propFTX from '../../../../public/webp/project/prop-ftx.webp';
import waterboyRentals from '../../../../public/webp/project/ricksbeach.webp';
import pigi from '../../../../public/webp/project/pigi.webp';
import waosim from '../../../../public/webp/project/Waosim.webp';
import zoomin from '../../../../public/webp/project/zoomin.webp';
import netrealty from '../../../../public/webp/project/netrealty.webp';
import ubuildabook from '../../../../public/webp/project/ubuildabook.webp';
import pangea from '../../../../public/webp/project/pangeaPod.webp';
import echt from '../../../../public/webp/project/echt.webp';
import whiskersNPaws from '../../../../public/webp/project/whiskersnpaws.webp';
import gymshark from '../../../../public/webp/project/gymshark.webp';
import tarshari from '../../../../public/webp/project/tarshari.webp';
import yellowbirdDental from '../../../../public/webp/project/yellowbirddental.webp';
import everPretty from '../../../../public/webp/project/everPrettycurve.webp';
import afterDark from '../../../../public/webp/project/afterdark.webp';
import blueBunglow from '../../../../public/webp/project/bluebungalow.webp';
import bluePrint from '../../../../public/webp/project/blueprint.webp';
import yhonk from '../../../../public/webp/project/yhonk.webp';
import teqDiligent from '../../../../public/webp/project/teq-diligent.webp';

import { IProject } from '@/components/type/type';

export const project: IProject[] = [
  {
    id: 1,
    title: 'Hopper Technology Solutions',
    redirectlink: 'hts',
    industries: ['Travel & Hospitality', 'Finance, Fintech & BFSI'],
    services: ['Custom Development Services', 'Cloud & DevOps'],
    description:
      'Provides scalable tech solutions for travel and fintech industries.',
    image: hts,
  },
  {
    id: 2,
    title: 'Planned',
    redirectlink: 'planned',
    industries: ['SaaS & Information Technology'],
    services: ['Custom Development Services', 'Cloud & DevOps'],
    description:
      'A SaaS platform offering modern IT and cloud-based development solutions.',
    image: planned,
  },
  {
    id: 3,
    title: 'Wikifarmer Market',
    redirectlink: 'wikifarmer',
    industries: ['Retail & Ecommerce', 'SaaS & Information Technology'],
    services: ['Custom Development Services', 'Data Engineering & Analytics'],
    description:
      'A global agricultural marketplace with digital and analytics solutions.',
    image: wikifarmer,
  },
  {
    id: 4,
    title: 'Spacerenta',
    redirectlink: 'spacerenta',
    industries: ['Construction & Real Estate'],
    services: ['Custom Development Services', 'Cloud & DevOps'],
    description:
      'Real estate rental solutions powered by cloud infrastructure.',
    image: spacerenta,
  },
  {
    id: 5,
    title: 'Tice Group',
    redirectlink: 'tice-group',
    industries: ['Retail & Ecommerce', 'Transport & Logistics'],
    services: ['Custom Development Services'],
    description: 'Digital solutions for retail and logistics operations.',
    image: ticeGroup,
  },
  {
    id: 6,
    title: 'Waterboy Rentals',
    redirectlink: 'waterboy-rentals',
    industries: ['Travel & Hospitality', 'Transport & Logistics'],
    services: ['Custom Development Services'],
    description: 'Rental solutions for travel and logistics businesses.',
    image: waterboyRentals,
  },
  {
    id: 7,
    title: 'Keto Cycle Diet',
    redirectlink: 'ketocycle',
    industries: ['Healthcare & Fitness'],
    services: ['Custom Development Services', 'Artificial Intelligence & ML'],
    description: 'AI-powered personalized diet and fitness platform.',
    image: ketoCycle,
  },
  {
    id: 8,
    title: 'Datapacket',
    redirectlink: 'datapacket',
    industries: ['SaaS & Information Technology', 'Energy & Utilities'],
    services: ['Cloud & DevOps', 'Custom Development Services'],
    description: 'Cloud infrastructure and networking services provider.',
    image: dataPacket,
  },
  {
    id: 9,
    title: 'ReUp Live',
    redirectlink: 'reup-live',
    industries: ['SaaS & Information Technology', 'Social Networking & Media'],
    services: [
      'Artificial Intelligence & ML',
      'Generative AI Solutions',
      'Custom Development Services',
    ],
    description: 'AI-powered social engagement and content platform.',
    image: reup,
  },
  {
    id: 10,
    title: 'Builders Spec',
    redirectlink: 'builders-spec',
    industries: ['Construction & Real Estate'],
    services: ['Custom Development Services'],
    description: 'Custom tech solutions for construction businesses.',
    image: buildersSpec,
  },
  {
    id: 11,
    title: 'PropFTX',
    redirectlink: 'propftx',
    industries: ['Finance, Fintech & BFSI', 'Construction & Real Estate'],
    services: ['Custom Development Services', 'Cloud & DevOps'],
    description: 'Fintech solutions tailored for real estate platforms.',
    image: propFTX,
  },
  {
    id: 12,
    title: 'Pigi',
    redirectlink: 'pigi',
    industries: ['Retail & Ecommerce', 'Healthcare & Fitness'],
    services: ['Custom Development Services'],
    description: 'Ecommerce and wellness-focused digital platform.',
    image: pigi,
  },
  {
    id: 13,
    title: 'Waosim',
    redirectlink: 'waosim',
    industries: ['SaaS & Information Technology'],
    services: ['Custom Development Services'],
    description: 'Simulation and SaaS-based digital solutions provider.',
    image: waosim,
  },
  {
    id: 14,
    title: 'Zoomin',
    redirectlink: 'zoomin',
    industries: ['Retail & Ecommerce'],
    services: ['Custom Development Services'],
    description: 'Online platform for personalized products and printing.',
    image: zoomin,
  },
  {
    id: 15,
    title: 'Netrealty',
    redirectlink: 'net-realty',
    industries: ['Construction & Real Estate'],
    services: ['Custom Development Services'],
    description: 'Real estate solutions powered by custom digital tools.',
    image: netrealty,
  },
  {
    id: 16,
    title: 'UBuildABook',
    redirectlink: 'ubuildabook',
    industries: ['Retail & Ecommerce', 'Education & E-Learning'],
    services: ['Custom Development Services'],
    description: 'Platform to create and publish custom books online.',
    image: ubuildabook,
  },
  {
    id: 17,
    title: 'Pangea Pod Hotel',
    redirectlink: 'pangea-pod-hotel',
    industries: ['Food & Restaurant', 'Travel & Hospitality'],
    services: ['Custom Development Services'],
    description: 'Modern pod-style hotel experience with digital integration.',
    image: pangea,
  },
  {
    id: 18,
    title: 'Echt Apparel',
    redirectlink: 'echt-apparel',
    industries: ['Retail & Ecommerce', 'Healthcare & Fitness'],
    services: ['Custom Development Services'],
    description: 'Fitness apparel brand with ecommerce solutions.',
    image: echt,
  },
  {
    id: 19,
    title: 'Whiskers n paws',
    redirectlink: 'whiskers-n-paws',
    industries: ['Retail & Ecommerce'],
    services: ['Custom Development Services'],
    description: 'Pet lifestyle ecommerce platform.',
    image: whiskersNPaws,
  },
  {
    id: 20,
    title: 'Gym Shark',
    redirectlink: 'gymshark',
    industries: ['Retail & Ecommerce', 'Healthcare & Fitness'],
    services: ['Custom Development Services', 'Cloud & DevOps'],
    description:
      'Global fitness apparel brand with scalable ecommerce systems.',
    image: gymshark,
  },
  {
    id: 21,
    title: 'Tarshari',
    redirectlink: 'tarshari',
    industries: ['Retail & Ecommerce'],
    services: ['Custom Development Services'],
    description:
      'Food and restaurant platform with digital ordering solutions.',
    image: tarshari,
  },
  {
    id: 22,
    title: 'YellowBird Dental',
    redirectlink: 'yellow-bird-dental',
    industries: ['Healthcare & Fitness'],
    services: ['Custom Development Services'],
    description: 'Dental care platform with modern digital solutions.',
    image: yellowbirdDental,
  },
  {
    id: 23,
    title: 'Ever Pretty',
    redirectlink: 'ever-pretty',
    industries: [''],
    services: ['Custom Development Services'],
    description: 'Online fashion retailer for affordable dresses.',
    image: everPretty,
  },
  {
    id: 24,
    title: 'Afterdark',
    redirectlink: 'afterdark',
    industries: ['Retail & Ecommerce'],
    services: ['Custom Development Services'],
    description: 'Entertainment and nightlife social platform.',
    image: afterDark,
  },
  {
    id: 25,
    title: 'Blue Bungalow',
    redirectlink: 'blue-bungalow',
    industries: ['Retail & Ecommerce'],
    services: ['Custom Development Services'],
    description: 'Fashion ecommerce platform with curated collections.',
    image: blueBunglow,
  },
  {
    id: 26,
    title: 'Blueprint',
    redirectlink: 'blue-print',
    industries: ['Retail & Ecommerce'],
    services: ['Custom Development Services'],
    description: 'Retail solutions provider with digital commerce tools.',
    image: bluePrint,
  },
  {
    id: 27,
    title: 'Teq Diligent',
    redirectlink: 'teq-diligent',
    industries: ['SaaS & Information Technology'],
    services: [
      'Custom Development Services',
      'Cloud & DevOps',
      'Data Engineering & Analytics',
    ],
    description:
      'IT services company offering cloud, data, and development solutions.',
    image: teqDiligent,
  },
  {
    id: 28,
    title: 'Yhonk',
    redirectlink: 'yhonk',
    industries: ['Transport & Logistics', 'SaaS & Information Technology'],
    services: ['Custom Development Services'],
    description:
      'Smart mobility and logistics platform powered by SaaS technology.',
    image: yhonk,
  },
];

export const exploreProjects = {
  heading: `Explore Projects`,
  description: `Here’s an overview of some of the projects we’ve delivered,
      showcasing our attention to detail and problem-solving approach.`,
  buttonName: 'View All',
  buttonLink: '/our-work',
};
